import moment from 'moment';
import * as React from 'react';

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import { formatDate } from '../../utils/date-utils';
import * as dates from 'date-arithmetic';

interface ICalendarHeaderDateProps {
  date: Date;
  currentView: string;
  onDateChange: (date: Date) => void;
  sm?: boolean;
  minDate?: Date;
}
export const CalendarHeaderDate: React.FunctionComponent<ICalendarHeaderDateProps> = (
  props
) => {
  const currentView: any = props.currentView;
  const date = props.date;
  const next = () => {
    const newDate = dates.add(date, 1, currentView);
    props.onDateChange(newDate);
  };
  const prev = () => {
    if (canGoBeforeMinDate) {
      const newDate = dates.add(date, -1, currentView);
      props.onDateChange(newDate);
    }
  };

  const dayDisplay = () => {
    return (
      <React.Fragment>
        <div
          className={`text-center ${
            props.sm ? 'd-flex align-items-baseline' : ''
          }`}
        >
          {props.sm && <i className="icon-activity mr-2"></i>}
          <h2
            className={`${
              props.sm
                ? 'font-sm text-dark mb-0 font-weight-semibold'
                : 'mb-1 font-weight-normal '
            }`}
          >
            {formatDate(date, 'DD MMM YYYY')}
          </h2>
          <div
            className={`font-xs ${
              props.sm
                ? 'font-sm text-dark font-weight-semibold'
                : 'text-gray-500'
            }`}
          >
            {formatDate(date, 'dddd')}
          </div>
        </div>
      </React.Fragment>
    );
  };

  const monthDisplay = () => {
    return (
      <React.Fragment>
        <div className="text-center">
          <h2 className="mb-1 font-weight-normal">
            {formatDate(date, 'MMMM')}
          </h2>
          <div className="text-gray-500 font-xs">
            {formatDate(date, 'YYYY')}{' '}
          </div>
        </div>
      </React.Fragment>
    );
  };

  const weekDisplay = () => {
    const startWeek = moment(date).startOf('week').toDate();
    const endWeek = moment(date).endOf('week').toDate();
    const weekNumber = moment(date).week();
    return (
      <React.Fragment>
        <div className="text-center">
          <h2 className="mb-1 font-weight-normal">
            {formatDate(startWeek, 'DD MMM')} -{' '}
            {formatDate(endWeek, 'DD MMM YYYY')}
          </h2>
          <div className="text-gray-500 font-xs">Week {weekNumber}</div>
        </div>
      </React.Fragment>
    );
  };

  const dateDisplay = () => {
    return (
      <React.Fragment>
        {currentView === 'day' && dayDisplay()}
        {currentView === 'week' && weekDisplay()}
        {currentView === 'month' && monthDisplay()}
      </React.Fragment>
    );
  };

  let canGoBeforeMinDate = true;
  if (
    props.minDate &&
    moment(props.minDate).isSameOrAfter(moment(date), 'day')
  ) {
    canGoBeforeMinDate = false;
  }

  return (
    <div
      className={`d-inline-flex align-items-baseline ${
        props.sm ? 'w-100 px-3' : ''
      }`}
    >
      <div
        onClick={prev}
        className={`p-1 ${canGoBeforeMinDate ? 'cursor-pointer' : ''} ${
          props.sm ? 'ml-auto' : ''
        }`}
      >
        {canGoBeforeMinDate && <i className="icon-chevron-left"></i>}
      </div>

      <div className={props.sm ? 'order-first' : ''}>{dateDisplay()}</div>
      <div onClick={next} className="p-1 cursor-pointer">
        <i className="icon-chevron-right"></i>
      </div>
    </div>
  );
};
